// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","spinner":"Loading_spinner__t04Qq","spin":"Loading_spin__2KgBV"};